module.exports = __webpack_public_path__ + "assets/5bed67c97449fcf17a5737584ada945f.mp3";